import React, { Fragment, useEffect } from 'react'
import HeaderImage from '../../img/homepage-header.png'
import { Link } from 'react-router-dom'
import { Fab } from '@material-ui/core'
import { makeStyles, lighten } from '@material-ui/core/styles'
import { ReactComponent as LockIcon } from '../../img/lock-icon.svg'
import { ReactComponent as LoginIcon } from '../../img/login-icon.svg'
import { ReactComponent as PasswordIcon } from '../../img/password-icon.svg'
import { ReactComponent as HouseIcon } from '../../img/house-icon.svg'
import { ReactComponent as MazeIcon } from '../../img/maze-icon.svg'
import { ReactComponent as RecycleIcon } from '../../img/recycle-icon.svg'
import { Grid } from '@material-ui/core'
import { Helmet } from 'react-helmet'


const useStyles = makeStyles(theme => ({
    porgrammersButton: {
        // width: '15vw',
        color: 'white',
        background: '#d7bb77',
        '&:hover, &:focus': {
            background: lighten('#d7bb77', .5),
            border: 'none'
        },
    },
    profileButton: {
        // width: '15vw',
        color: 'white',
        background: '#00AD9F',
        '&:hover, &:focus': {
            background: lighten('#00AD9F', .5),
            border: 'none'
        },
    }
}))

const Home = () => {
    const styles = useStyles()
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>آتی‌نو، هویت دیجیتالی تو - خانه</title>
            </Helmet>

            <main id='home' style={{ flexGrow: 1 }}>

                <section id='section-1'>
                    <img src={HeaderImage} alt='' />
                </section>

                <section id='section-2'>
                    <Grid container spacing={0} justify='center'>
                        <Grid item md={6} sm={12} id='programmers-btn'>
                            <Link to='/programmers'>
                                <Fab id='fab1' variant='extended' className={styles.porgrammersButton}>برنامه نویس ها</Fab>
                            </Link>
                        </Grid>

                        <Grid item md={6} xs={12} id='dashboard-btn'>
                            <Link to='/people' >
                                <Fab id='fab2' variant='extended' className={styles.profileButton}>کاربران عادی</Fab>
                            </Link>
                        </Grid>
                    </Grid>
                </section>

                <section id='section-3'>
                    <h3>چرا کاربران اینترنتی یک هویت «آتی‌نو» خواهند داشت؟</h3>

                    <Grid container spacing={4} justify='center'>
                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <LockIcon className='custom-icon' />
                                <p>۱ بار ثبت  نام، برای ۱۰۰۰ سایت مختلف! این یعنی «صرفه جویی در زمان» و «راحتی بیشتر»</p>
                            </div>
                        </Grid>

                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <LoginIcon className='custom-icon' />
                                <p>ورود به سایت‌های مختلف عضو «منم» فقط با ۱ کلیک!</p>
                            </div>
                        </Grid>

                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <PasswordIcon className='custom-icon' />
                                <p>امنیت بیشتر و عدم نیاز به ذخیره چند نام کاربردی و پسوورد !</p>
                            </div>
                        </Grid>
                    </Grid>

                    <hr />

                    <h3>چرا وب‌ سایت یا اپلیکیشن شما «مَنَم» رو لازم داره؟!</h3>

                    <Grid container spacing={4} justify='center'>
                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <HouseIcon className='custom-icon' />
                                <p>تایید اعتبار با چند فاکتور مختلف(MFA) یعنی «امنیت بیشتر» برای شما و «راحتی بیشتر» برای مخاطب</p>
                            </div>
                        </Grid>

                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <MazeIcon className='custom-icon' />
                                <p>بهبود تجربه مشتری در راستای افزایش رضایتمندی</p>
                            </div>
                        </Grid>

                        <Grid item md={3} sm={12}>
                            <div className="custom-card">
                                <RecycleIcon className='custom-icon' />
                                <p>افزایش پویایی سیستم و توسعه سرویس بدون نگرانی</p>
                            </div>
                        </Grid>
                    </Grid>
                </section>

                <section id='section-4'>
                    <h2>مزایای استفاده از سرویس احراز هویت (IDaaS)</h2>

                    <Grid container spacing={2} justify='center'>
                        <Grid item md={2} sm={12}>
                            <div className="circle-card shadow">
                                <p>تعبیه سرویس ثبت نام (sign on) با هزینه و زمان کمتر</p>
                            </div>
                        </Grid>

                        <Grid item md={2} sm={12}>
                            <div className="circle-card shadow">
                                <p>افزایش دقت در پایش مخاطبان و افزایش امنیت</p>
                            </div>
                        </Grid>

                        <Grid item md={2} sm={12}>
                            <div className="circle-card shadow">
                                <p>کاهش سربار تامین و نگهداری سیستم</p>
                            </div>
                        </Grid>

                        <Grid item md={2} sm={12}>
                            <div className="circle-card shadow">
                                <p>ورود یکپارچه به سایت‌های مختلف Single Sign-on (SSO)</p>
                            </div>
                        </Grid>
                    </Grid>
                </section>

            </main>
        </>
    )
}

export default Home